import React from "react";
import "./styles.css";

interface ButtonProps {
  onClick?: () => void;
  variant?: "primary" | "secondary" | "outline" | "tertiary" | "quaternary";
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  children: React.ReactNode;
  id?: string;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  onClick,
  variant = "primary",
  type = "button",
  disabled = false,
  children,
  id,
  className,
}) => {
  return (
    <button
      className={`btn btn-${variant} ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      id={id}
    >
      {children}
    </button>
  );
};
